// extracted by mini-css-extract-plugin
export var actionButton = "_m0-t";
export var buttonContainer = "_m0-0";
export var buttonContainer2 = "_m0-1";
export var buttonSection = "_m0-2";
export var details = "_m0-3";
export var dropdownItem = "_m0-5";
export var dropdownItemsContainer = "_m0-4";
export var fileInput = "_m0-r";
export var headerButton = "_m0-6";
export var icon = "_m0-7";
export var input = "_m0-8";
export var macroListItem = "_m0-9";
export var mainContent = "_m0-a";
export var microText = "_m0-b";
export var modal = "_m0-w";
export var optionsButton = "_m0-c";
export var paperclip = "_m0-s";
export var pillContent = "_m0-d";
export var preview = "_m0-e";
export var preview2 = "_m0-f";
export var quillEditor = "_m0-q";
export var selectedMacro = "_m0-g";
export var sidebar = "_m0-h";
export var sidebarHeader = "_m0-j";
export var sidebarList = "_m0-i";
export var sidebarListItem = "_m0-k";
export var sidebarSearch = "_m0-l";
export var snoozeDurationWrapper = "_m0-v";
export var statusPillContainer = "_m0-m";
export var tagsContainer = "_m0-n";
export var unselectedMacro = "_m0-o";
export var variable = "_m0-u";
export var wrapper = "_m0-p";